import { IS_ELASTIC_ENABLED_COOKIE_KEY } from "../../utils/constants"

/**
 * Checks if ElasticSearch backend should be used.
 * Returns true if:
 * - Config NEXT_PUBLIC_SEARCH_ACTIVE_BACKEND is 'elastic', OR
 * - Cookie 'is_elastic_enabled' is 'true'
 *
 * Pattern from: maple/frontend/strat/strat/search/backendUtils.ts
 */

/**
 * For server-side (getServerSideProps) - pass parsed cookies object
 * @param {Object} cookies - Parsed cookies object
 * @returns {boolean} - Whether ElasticSearch backend is enabled
 */
export const isElasticBackend = (cookies = {}) => {
  const configIsElastic = process.env.NEXT_PUBLIC_SEARCH_ACTIVE_BACKEND === "elastic"
  const cookieIsElastic = cookies[IS_ELASTIC_ENABLED_COOKIE_KEY] === "true"
  return configIsElastic || cookieIsElastic
}

/**
 * For client-side - reads document.cookie directly
 * Use this in React components and client-side code
 * @returns {boolean} - Whether ElasticSearch backend is enabled
 */
export const isElasticBackendClient = () => {
  const configIsElastic = process.env.NEXT_PUBLIC_SEARCH_ACTIVE_BACKEND === "elastic"

  if (typeof document === "undefined") {
    return configIsElastic
  }

  try {
    const cookieString = document.cookie
    const cookieMatch = cookieString.match(new RegExp(`(?:^|; )${IS_ELASTIC_ENABLED_COOKIE_KEY}=([^;]*)`))
    if (cookieMatch) {
      const cookieIsElastic = decodeURIComponent(cookieMatch[1]) === "true"
      return configIsElastic || cookieIsElastic
    }
  } catch (error) {
    // If cookie access fails, return config value only
  }

  return configIsElastic
}
